import { UbiverseSequenceData } from '../types';
import CONST from '../consts';

export const delays = [ 8, 9, 10, 11, 12, 14, 16, 22, 30, 40 ];

interface sequenceForRepeatFromPagination {
  data: number[],
  pagination: number,
  numOfElementsLeft: number
}

export function getSequenceFromPagination(data: number[], pagination: number): number[] {
  return data.slice(pagination * CONST.bufferSize, (pagination + 1) * CONST.bufferSize)
}

export function filterSequenceDataByRepeatRange(data: number[], fromSample: number, toSample: number): number[] {
  if (data.length < 2) return [];
  const rangeStart = Math.min(fromSample, toSample);
  const rangeEnd = Math.max(fromSample, toSample);
  const filtered: number[] = [];

  for (let index = 0; index < data.length - 1; index += 2) {
    const raiseSample = data[index];
    const fallSample = data[index + 1];
    if (fallSample >= rangeStart && fallSample <= rangeEnd) {
      filtered.push(raiseSample, fallSample);
    }
  }

  return filtered;
}

export function getSequenceForRepeatFromPagination(
  data: number[],
  pagination: number,
  numOfElementsLeft: number,
  durationBySamples: number,
  maxBufferSize: number
): sequenceForRepeatFromPagination {
  let _pagination = pagination;
  
  let chunks: number[] = []

  console.log('creating data with the following inputs')
  console.log('data', data)
  console.log('pagination', pagination)
  console.log('numOfElementsLeft', numOfElementsLeft)
  console.log('durationBySamples', durationBySamples)
  console.log('maxBufferSize', maxBufferSize)

  if (data.length === 0) {
    console.error('data array is empty!!!')
    return {
      data: [],
      pagination: 0,
      numOfElementsLeft: 0
    }
  }

  // first, add the left over elements from previous run
  if (numOfElementsLeft > 0) {
    const _data = data.slice(numOfElementsLeft - data.length, data.length).map(d => d + _pagination * durationBySamples)
    chunks = [...chunks, ..._data]
  }

  console.log('chunks', chunks)

  // and keep adding chunks until we have the desired number of elements
  while (chunks.length < maxBufferSize) {
    chunks = [...chunks, ...data.map(d => d + _pagination * durationBySamples)]
    console.log('chunks', chunks)
    if (chunks.length < maxBufferSize) {
      _pagination++
      console.log('pagination', _pagination)
    }
  }

  const _numOfElementsLeft = data.length - (chunks.length - maxBufferSize)

  return {
    data: chunks.slice(0, maxBufferSize),
    pagination: _pagination,
    numOfElementsLeft: _numOfElementsLeft
  }
}

export function convertPayloadToTrigger(payload: UbiverseSequenceData, majorCounts: number, bpm: number) {
  console.log(payload, 'payload')
  let _intensity = Math.floor(payload.intensity);
  if (_intensity < 1) _intensity = 1;
  if (_intensity > 10) _intensity = 10;

  const delay = delays[_intensity - 1];

  const majorSamples = ((60 / bpm) * majorCounts * 1000) / 5
  
  const timestampBySample = majorSamples * (payload.position / majorCounts) + delays[delays.length - 1];
  return [timestampBySample - delay, timestampBySample]
  // const timestamp = Math.round(payload.timestamp);
  // const offsetTimestamp = timestamp + delays[delays.length - 1]; // +40

  // return [offsetTimestamp - delay, offsetTimestamp];
}

export function convertSequenceToData(sequence: UbiverseSequenceData[] | string, offsetTime: number = 0, majorCounts: number = 4, bpm: number = 120) {
  let data: number[] = [];
  const _sequence = typeof(sequence) === 'string' ? JSON.parse(sequence) as UbiverseSequenceData[] : sequence;
  _sequence.forEach((t: UbiverseSequenceData) => {
    data = [...data, ...convertPayloadToTrigger({ intensity: t.intensity, timestamp: t.timestamp + offsetTime, position: t.position }, majorCounts, bpm)];
  });
  return data;
}
